import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type ConversationNavigationState = {
  lastViewedByMatter: Partial<{ [matterId: string]: string }>
}

type LastViewedConversation = {
  id: string
  matter_id: string | null
}

const initialState: ConversationNavigationState = {
  lastViewedByMatter: {},
}

/**
 * Conversation Navigation Slice
 * Holds matter-aware navigation state for conversations
 */
export const conversationNavigationSlice = createSlice({
  name: 'conversationNavigationState',
  initialState,
  reducers: {
    // ============== Slice Actions ============== >
    nullifyData: () => initialState,

    // Set the last viewed conversation for a given matter
    setLastViewedByMatter: (
      state,
      action: PayloadAction<{
        conversation: LastViewedConversation
        activeMatterId: string | null
      }>
    ) => {
      const { conversation, activeMatterId } = action.payload

      // Must have a matter selected and the conversation must belong to it
      if (!activeMatterId || !conversation || conversation.matter_id !== activeMatterId) return

      state.lastViewedByMatter[activeMatterId] = conversation.id
    },
  },
})

// Actions
export const ConversationNavigationActions = conversationNavigationSlice.actions

export default conversationNavigationSlice.reducer
